<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <p-table sortField="Status" sortMode="single"
        rowGroupMode="subheader" groupRowsBy="Status"
        #miSurvey [value]="tankAbstract" dataKey="LotNos" [rows]="15" [paginator]="true"
            [globalFilterFields]="[
		'LotNos',
		'TotalFailedRecords',
		'AmtFailedRecords',
		'TotalSuccessfulRecords',
		'AmtSuccessfulRecords',
		'TotalRecords',
        'SumTotalAmt',
        'TotalNoOfLots',
        'Stage',
        'Status'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" (onFilter)="tableDataFunction($event)" (onPage)="onPage($event)"
            [loading]="loading" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}" [scrollable]="true" scrollHeight={{tableHeight}}>
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'LOT_CONSOLIDATED_REPORT'| translate}}</h5>
                    <span>
                        <button (click)="menu.toggle($event)" pButton pRipple label="{{'DOWNLOAD' | translate}}"
                            icon="pi pi-download" class="p-button-help"></button>

                        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    </span>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="custom-width">{{'STAGE'| translate}}</th>
                <th class="custom-width-2">{{'LOT_NO'| translate}}</th>
                <th class="custom-width-3">{{'NO_OF_LOTS'| translate}}</th>
                <th class="custom-width-3">{{'TOTAL_RECORDS'| translate}}</th>

                <th class="custom-width-3">{{'TOTAL_PFMS_AMOUNT'| translate}}</th>
                <th class="custom-width-3">{{'SUCCESSFUL_RECORDS'| translate}}</th>
                <th class="custom-width-3">{{'SUCCESSFUL_AMOUNT'| translate}}</th>
                
                <th class="custom-width-3">{{'FAILED_RECORDS'| translate}}</th>
                <th class="custom-width-3">{{'FAILED_AMOUNT'| translate}}</th>

            </tr>
        </ng-template>
       
        
        <ng-template pTemplate="groupheader" let-customer>
            <tr pRowGroupHeader>
                <td colspan="5">
                    <img [alt]="customer.Status" />
                    <span class="font-bold ml-2">{{customer.Status}}</span>
                </td>
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="groupfooter" let-customer>
            <tr>
                <td colspan="5" class="text-right font-bold pr-6">
                    Total Customers: {{calculateCustomerTotal(customer.representative.name)}}
                </td>
            </tr>
        </ng-template> -->
        <ng-template pTemplate="body" let-tankAbstract let-rowIndex="rowIndex">
            <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(tankAbstract)}">
                <td class="custom-width">{{tankAbstract.Stage}}</td>
                <td class="custom-width-2">{{tankAbstract.LotNos}}</td>
                <td class="custom-width-3">{{tankAbstract.TotalNoOfLots}}</td>
                <td class="custom-width-3">{{tankAbstract.TotalRecords}}</td>

                <td class="custom-width-3">{{tankAbstract.SumTotalAmt}}</td>

                <td class="custom-width-3">{{tankAbstract.TotalSuccessfulRecords}}</td>
                <td class="custom-width-3">{{tankAbstract.AmtSuccessfulRecords}}</td>

                <td class="custom-width-3">{{tankAbstract.TotalFailedRecords}}</td>
                <td class="custom-width-3">{{tankAbstract.AmtFailedRecords}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No Data found.</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <div class="flex  justify-content-between flex-column ">
                    <div class="flex">
                        <div
                            style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                        </div>{{'Uploaded'| translate}}
                    </div>
                    <div class="flex">
                        <div
                            style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                        </div>{{'Pending'| translate}}
                    </div>
                </div>
            </div>
        </ng-template>
    </p-table>
</p-card>